/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { login, clearError } from '../../store/slices/authSlice';
import { ReactComponent as Shape2 } from './2.svg';
import { ReactComponent as Shape3 } from './3.svg';
import logo from '../../styles/logo.png';
const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [rememberMe, setRememberMe] = useState(false);
  const [showNotification, setShowNotification] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading, error, isAuthenticated } = useSelector((state) => state.auth);

  useEffect(() => {
    if (isAuthenticated) {
      navigate('/');
    }
  }, [isAuthenticated, navigate]);

  useEffect(() => {
    if (error) {
      setShowNotification(true);
      const timer = setTimeout(() => {
        setShowNotification(false);
        dispatch(clearError());
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [error, dispatch]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const result = await dispatch(login({ email, password, rememberMe }));
    if (!result.error) {
      navigate('/');
    }
  };

  return (
    <div
      className="relative w-screen h-screen overflow-hidden"
      style={{
        background: 'radial-gradient(58.43% 103.88% at 56.74% 50%, #0085FF 0%, #003465 100%)'
      }}
    >
      {/* SVG Shapes */}
      {/* <div className="absolute top-[10%] left-[50%] -translate-x-1/2 w-[15%] h-[20%]">
        <Shape1 className="w-full h-full" />
      </div> */}
      <div className="absolute bottom-[15%] left-[10%] w-[25%] h-[30%]">
        <Shape2 className="w-full h-full" />
      </div>
      <div className="absolute bottom-[15%] right-[10%] w-[20%] h-[15%]">
        <Shape3 className="w-full h-full" />
      </div>

      {/* Glass Card with Login Form */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[60%] h-[70%] rounded-[24px] p-8 flex items-center justify-center"
        style={{
          background: 'none',
        }}
      >
        <div className="w-[400px] backdrop-blur-xl bg-white/10 rounded-3xl p-8">
          <div className="text-center mb-8">
            <div className="flex justify-center items-center mb-2">
              <img src={logo} alt="logo" style={{ width: '5rem', height: '5rem' }} />
            </div>
            <h2 className="text-xl font-semibold text-white">QRTalkie</h2>
          </div>

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-white text-sm mb-2">Email</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="username@gmail.com"
                className="w-full px-4 py-3 bg-white/5 border border-white/10 rounded-xl text-white placeholder-white/30
                         focus:outline-none focus:border-white/30 focus:ring-1 focus:ring-white/30"
                required
              />
            </div>

            <div>
              <label className="block text-white text-sm mb-2">Password</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Password"
                className="w-full px-4 py-3 bg-white/5 border border-white/10 rounded-xl text-white placeholder-white/30
                         focus:outline-none focus:border-white/30 focus:ring-1 focus:ring-white/30"
                required
              />
            </div>

            {/* <div className="flex items-center justify-between">
              <div className="flex items-center">
                <input
                  type="checkbox"
                  id="remember-me"
                  checked={rememberMe}
                  onChange={(e) => setRememberMe(e.target.checked)}
                  className="h-4 w-4 rounded border-white/30 bg-white/5 text-blue-500 focus:ring-blue-500"
                />
                <label htmlFor="remember-me" className="ml-2 text-white/70 text-sm">
                  Remember me
                </label>
              </div>
              <a href="#" className="text-white/70 text-sm hover:text-white">Forgot Password?</a>
            </div> */}

            <button
              type="submit"
              disabled={loading}
              className="w-full py-3 bg-[#001B54] text-white rounded-xl font-semibold hover:bg-[#002472] transition-colors
                       disabled:opacity-50 disabled:cursor-not-allowed"
            >
              Sign in
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
